/**
 * AppLayout — persistent top bar that wraps every authenticated route.
 *
 * Why this exists: previously each authenticated page rolled its own "← Back"
 * button with ad-hoc destinations, producing dead-end loops (notably between
 * /billing and /org/billing) and no consistent escape to /app. The logo is now
 * the universal home affordance, and the user menu is always one click away.
 *
 * The top bar lives in shell/TopBar. Page-internal navigation (e.g. the /app
 * Templates/Workflows/Files tabs in NavigationTabs) stays inside MainApp —
 * those control mode state, not URL state.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from './shell/TopBar';

export default function AppLayout() {
  return (
    <>
      <TopBar />
      <Outlet />
    </>
  );
}
